// extracted by mini-css-extract-plugin
export var button = "_lq-2";
export var card = "_lq-0";
export var closeButtonContainer = "_lq-3";
export var iconContainer = "_lq-1";